<template>
  <editor
    ref="toastuiEditor"
    :initial-value="value"
    :options="editorOptions"
    height="270px"
    initial-edit-type="wysiwyg"
    preview-style="vertical"
    @change="changeHandler"
  />
</template>
<script>
import "codemirror/lib/codemirror.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import { storage } from "@/firebase";
import { v4 } from "uuid";

import { Editor } from "@toast-ui/vue-editor";

export default {
  components: {
    editor: Editor,
  },
  props: {
    value: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      ui: null,
      editorOptions: {
        hideModeSwitch: true,
        usageStatistics: false,
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.$refs.toastuiEditor && this.$refs.toastuiEditor.invoke("getMarkdown") != this.value) {
          this.$refs.toastuiEditor.invoke("setMarkdown", this.value, false);
        }
      },
    },
  },
  mounted() {
    this.ui = this.$refs.toastuiEditor.invoke("getUI");
    window.mdUi = this.ui;

    this.ui.getToolbar().addItem({
      type: "button",
      options: {
        className: "first",
        event: "clickCustomButton",
        text: this.$t("fileUpload"),
        style: "color: #000; background: none; width: auto; font-weight: bold;line-height: 5px;",
      },
    });

    this.ui.getToolbar()._eventManager.addEventType("clickCustomButton");
    this.ui.getToolbar()._eventManager.listen("clickCustomButton", () => {
      this.promptFile().then(this.uploadFile);
    });

    window.Editor = Editor;
  },
  methods: {
    changeHandler() {
      this.$emit("input", this.$refs.toastuiEditor.invoke("getMarkdown"));
    },
    promptFile(contentType, multiple) {
      var input = document.createElement("input");
      input.type = "file";
      input.multiple = multiple;
      input.accept = contentType;
      return new Promise(function (resolve) {
        document.activeElement.onfocus = function () {
          document.activeElement.onfocus = null;
          //setTimeout(resolve, 100)
        };
        input.onchange = function () {
          var files = Array.from(input.files);
          if (multiple) return resolve(files);
          resolve(files[0]);
        };
        input.click();
      });
    },
    async uploadFile(file) {
      console.log(file);
      if (file) {
        file = Array.isArray(file) ? file : [file];
        file.forEach(async (f) => {
          let ref = storage
            .refFromURL("gs://travio-user_uploads/")
            .child(`user_uploads/${this.$store.getters.getCurrentUser.uid}/${v4()}/${f.name}`);
          await ref.put(f);
          let url = await ref.getDownloadURL();
          this.$refs.toastuiEditor.invoke("setMarkdown", this.value + `\n[**${f.name}**](${url})`, false);
          console.log("insertText", `[${f.name}](${url})`);
        });
      }
    },
  },
};
</script>
